import { gql } from '@apollo/client'

export const CREATE_CAMPAIGN_SUBCAMPAIGN = gql`
  mutation CreateCampaignSubcampaign($input: CreateCampaignSubcampaignInput!) {
    createCampaignSubcampaign(input: $input) {
      id
    }
  }
`

export const CANCEL_TRIPS = gql`
  mutation CancelTrips($input: cancelTripsInput!) {
    cancelTrips(input: $input)
  }
`

export const CANCEL_LOCAL_TRIP = gql`
  mutation DeactivateLocalTrip($tripId: ID!) {
    deactivateTrip(tripId: $tripId) @client
  }
`
export const ACTIVATE_TRIP_SALE = gql`
  mutation ActivateTripSale($tripId: ID!) {
    activateTripSale(input: { id: $tripId })
  }
`

export const ACTIVATE_LOCAL_TRIP_SALE = gql`
  mutation ActivateLocalTripSale($tripId: ID!) {
    activateTripSale(tripId: $tripId) @client
  }
`

export const DEACTIVATE_TRIP_SALE = gql`
  mutation DeactivateTripSale($tripId: ID!) {
    deactivateTripSale(input: { id: $tripId })
  }
`

export const DEACTIVATE_LOCAL_TRIP_SALE = gql`
  mutation DeactivateLocalTripSale($tripId: ID!) {
    deactivateTripSale(tripId: $tripId) @client
  }
`

export const CHANGE_LOCAL_TRIP_VEHICLE = gql`
  mutation ChangeLocalTripVehicle($tripId: ID!, $vehicle: TripVehicle!) {
    changeTripVehicle(tripId: $tripId, vehicle: $vehicle) @client
  }
`

export const CHANGE_DRIVER = gql`
  mutation ChangeDriver($id: UUID!, $input: ChangeTTripDriverInput!) {
    changeTTripDriver(id: $id, input: $input)
  }
`

export const ADD_TRIP_NOTE = gql`
  mutation AddTripNote($input: AddTripNoteInput!) {
    addTripNote(input: $input)
  }
`

export const CHANGE_TRIP_CONFIRMATION_MODALITIES = gql`
  mutation ChangeTripConfirmationModalities($input: ChangeTripConfirmationModalitiesInput!) {
    changeTripConfirmationModalities(input: $input)
  }
`
